// extracted by mini-css-extract-plugin
export default {"footer":"footer--No_Lw","footer-content":"footer-content--B4uXv","footer-version":"footer-version--DOdz6"};